class SearchSubmit

  URL: '/sky/'
  mobileURL: '/s/AR000.php'
  defaultButton: '.js-search-submit'

  constructor: (@elm, @mobile = false) ->
    @ps_cd = sessionStorage.getItem('ps_cd')
    @$submit = @elm.find @defaultButton
    @$submit.on 'click', @submitClick
    @addParameter = if @ps_cd
      "?ps_cd=#{@ps_cd}"
    else
      ''

  submitClick: (event) =>
    { elm } = @
    event.preventDefault()
    $data = elm.find 'input, select'
    data  = {}
    _.forEach $data, (_elm) ->
      return true unless _elm.name
      if _elm.name is 'car'
        data[_elm.name] = unless data[_elm.name]
          _elm.value
        else
          data[_elm.name] + ',' + _elm.value
      else
        data[_elm.name] = _elm.value.replace /:/g , '-'

    data.go          = '-' unless data.go
    data.return      = '-' unless data.return
    data.area2       = '0' unless data.area2
    data.area3       = '0' unless data.area3
    data.go_time     = '-' unless data.go_time
    data.return_time = '-' unless data.return_time
    data.car         = ',' unless data.car
    data.narrow      = ',' unless data.narrow

    @transition data

  transition: (data) ->
    { mobile, mobileURL, URL, addParameter } = @
    url = if mobile
      "#{URL}searches/car_class/00/03/#{data.area1}/#{data.area2}/#{data.go}/#{data.return}/#{data.go_time}/#{data.return_time}/#{data.car}/#{data.narrow}/#{data.area3}"
    else
      "#{URL}searches/car_class/00/03/#{data.area1}/#{data.area2}/#{data.go}/#{data.return}/#{data.go_time}/#{data.return_time}/#{data.car}/#{data.narrow}/#{data.area3}"

    location.href = "#{url}/#{addParameter}"
    # console.log "#{url}/#{addParameter}"

export default SearchSubmit



// WEBPACK FOOTER //
// ./webpack/imports/view/search-submit.coffee